import {
  Input,
  Component,
  TemplateRef,
  EventEmitter,
  Output,
} from "@angular/core";
import { Dropdown } from "./dropdown.service";

@Component({
  selector: "icn-dropdown-item",
  templateUrl: "./dropdown-item.component.html",
  styleUrls: ["./dropdown-item.component.scss"],
})
export class DropdownItemComponent {
  constructor(private dropdownService: Dropdown) {}

  @Input()
  selected: boolean = false;

  @Input()
  multiple: boolean = false;

  @Input()
  cssClass = "";

  @Input()
  isDefault: boolean;
  isShowDefaultStatus: boolean;

  @Input()
  overrideOnClickEvent: () => void;

  @Input()
  item: any;

  @Input()
  showSettings: boolean = false;

  @Input()
  selectable: boolean = true;

  @Input()
  textColor = "#232f3a";

  @Output()
  onSettingsClicked = new EventEmitter();

  @Input() title: string;
  @Input() titleTemplateRef: TemplateRef<any>;
  @Input() value: any;
  @Input() titleClass: string;

  onClick() {
    if (this.overrideOnClickEvent) {
      this.overrideOnClickEvent();
      return;
    }
    if (!this.selectable) {
      return;
    }
    this.dropdownService.itemClicked.emit(this);
    if (this.multiple && this.isDefault) {
      this.dropdownService.defaultUnchecked.emit();
    }
  }

  setAsDefault(event) {
    event.stopPropagation();
    this.dropdownService.setAsDefault.emit(this);
  }
}
